<template>
	<h3>Payment Details</h3>

	<Form class="form-container">
		<div v-for="field in formFields" :key="field.name" :class="['form-input', field.width]">
			<label :for="field.name">{{ field.label }}</label>
			<Field :id="field.name" :name="field.name" :type="field.type" v-model="field.value" disabled="true" />
		</div>
	</Form>
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	import { Form, Field } from 'vee-validate';
	import { FinancialInstitution } from '@/models/loans';

	interface FormField {
		name: string;
		label: string;
		type: string;
		value: any;
		width: string;
	}

	const props = defineProps<{
		financialInstitution: FinancialInstitution | null;
	}>();

	const formFields = ref<FormField[]>([
		{
			name: 'name',
			label: 'Send Payment To',
			type: 'string',
			value: props.financialInstitution?.name,
			width: 'col-4'
		},
		{
			name: 'routingNumber',
			label: 'Routing Number',
			type: 'string',
			value: props.financialInstitution?.routingNumber,
			width: 'col-3'
		},
		{
			name: 'accountNumber',
			label: 'Account Number',
			type: 'string',
			value: props.financialInstitution?.accountingNumber,
			width: 'col-3'
		}
	]);
</script>

<style scoped src="@/assets/css/loans/form.css"></style>

<style scoped>
	h3 {
		margin-top: 20px;
		margin-bottom: 15px;
	}
</style>
